import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
  install(Vue) {
    const socketHub = new Vue()
    Vue.prototype.$socketHub = socketHub

    // Provide methods to connect/disconnect from the SignalR hub
    let connection = null
    let startedPromise = null
    let manuallyClosed = false
    const logLevel = process.env.NODE_ENV === 'production' ? LogLevel.Error : LogLevel.Information

    Vue.prototype.startSocket = jwtToken => {
      connection = new HubConnectionBuilder()
        .withUrl(
          process.env.VUE_APP_SOCKET_URL,
          jwtToken ? { accessTokenFactory: () => jwtToken } : null,
        )
        .configureLogging(logLevel)
        .build()

      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on('ReceiveMessage', message => {
        if (process.env.VUE_APP_SHOW_CONSOLE_LOG === 'true') {
          console.log('Socket recieved:', message)
        }
        socketHub.$emit('message-received', { message })
      })

      function start() {
        if (
          connection &&
          connection.connection &&
          connection.connection.connectionState === 2
        ) {
          startedPromise = connection.start().then(() => {
            console.log('connection started')
          }).catch(err => {
            console.error('Failed to connect with hub', err)

            if (err.statusCode !== 401) {
              return new Promise((resolve, reject) =>
                setTimeout(
                  () =>
                    start()
                      .then(resolve)
                      .catch(reject),
                  5000,
                ),
              )
            }
          })
          return startedPromise
        } else {
          return startedPromise
        }
      }
      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      start()
    }

    Vue.prototype.stopSocket = () => {
      if (!startedPromise) return

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => {
          startedPromise = null
        })
    }

    socketHub.sendMessage = message => {
      if (!startedPromise) return

      return startedPromise
        .then(() => connection.invoke('SendMessageToAll', message))
        .catch(console.error)
    }

    Vue.prototype.sendSocket = (socketName, message) => {
      if (!startedPromise) return

      return startedPromise
        .then(() => connection.invoke(socketName, message))
        .catch(console.error)
    }
  },
}
